export enum AFWebLinkType {
  //both
  message = 'message',
  shareImage = 'shareImage',
  communityLevel = 'communityLevel',
  setLoading = 'setLoading',
  mapState = 'mapState',
  //receive
  consoleMessage = 'consoleMessage',
  getToast = 'getToast',
  getUserData = 'getUserData',
  goBack = 'goBack',
  moveToWebView = 'moveToWebView',
  moveToFishingBookWriter = 'moveToFishingBookWriter',
  moveToAdBanner = 'moveToAdBanner',
  moveToProfile = 'moveToProfile',
  moveToShop = 'moveToShop',
  moveToMagazineWebView = 'moveToMagazineWebView',
  moveToComments = 'moveToComments',
  moveToEventWebView = 'moveToEventWebView',
  moveToLink = 'moveToLink',
  moveToFishingBookDetail = 'moveToFishingBookDetail',
  moveToBottomTab = 'moveToBottomTab',
  onPressPostcode = 'onPressPostcode',
  openDatePicker = 'openDatePicker',
  onSignInInducement = 'onSignInInducement',
  popNavigation = 'popNavigation',
  shareUrl = 'shareUrl',
  pointMap = 'pointMap',
  navigate = 'navigate',
  onClose = 'onClose',
  onChangedCoin = 'onChangedCoin',
  onShopShare = 'onShopShare',
  showChannelTalk = 'showChannelTalk',
  hideChannelTalk = 'hideChannelTalk',
  openChannelTalk = 'openChannelTalk',
  setAppsflyerEvent = 'setAppsflyerEvent',
  topMenu = 'topMenu',
  advertiseStatus = 'advertiseStatus',
  sendSentryLog = 'sendSentryLog',
  getScreenSize = 'getScreenSize',
  returnMyPay = 'returnMyPay',
  screenEvent = 'screenEvent',
  mapOnSourceLayerPress = 'mapOnSourceLayerPress',
  openImageViewer = 'openImageViewer',
  openImagesViewer = 'openImagesViewer',
  onMenuPress = 'onMenuPress',
  onVisibleTopMenuChange = 'onVisibleTopMenuChange',
  onVisibleTopNavigationChange = 'onVisibleTopNavigationChange',
  onChangeCircleInsiderCreateModal = 'onChangeCircleInsiderCreateModal',
  onChangeCircleInsiderDeleteModal = 'onChangeCircleInsiderDeleteModal',
  onChangeSelectedCircleId = 'onChangeSelectedCircleId',

  //catch log
  onFishSpeciesPress = 'onFishSpeciesPress',
  onSetData = 'onSetData',
  onBookmarkPress = 'onBookmarkPress',
  onChangePickInfoModal = 'onChangePickInfoModal',

  //send
  datePickerMessage = 'datePickerMessage',
  postCodeMessage = 'postCodeMessage',
  userData = 'userData',
  loginUser = 'loginUser',
  onFocus = 'onFocus',
  coinRefresh = 'coinRefresh',
  onScrollTop = 'onScrollTop',
  screenSize = 'screenSize',
  linking = 'linking',
  accessToken = 'accessToken',
  insets = 'insets',
  visibleCommentInput = 'visibleCommentInput',
  setCommentData = 'setCommentData',
  onLoad = 'onLoad',
}

// 앱 console log 출력
export const sendConsoleMessage = (message: string): void => {
  RNPostMessage(AFWebLinkType.consoleMessage, message)
}

//링크이동
export function moveToLink(url?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: url,
        },
      })
    )
  }
}

//링크이동
export function moveToLinkDetail(url?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=shop-main&url=${url}`,
        },
      })
    )
  }
}

export function moveToLinkNaver(url?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
        },
      })
    )
  }
}

export function moveToLinkWebviewNaver(url?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToWebView',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
        },
      })
    )
  }
}

//주소공유?
export function shareUrl(url?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'shareUrl',
        targetFuncParams: { url: url },
      })
    )
  }
}

//공유?
export function onShopShare(title?: any, mainImage?: any, url?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'onShopShare',
        targetFuncParams: { title: title, mainImage: mainImage, url: url },
      })
    )
  }
}

export function onSignInInducement(): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'onSignInInducement',
      })
    )
  }
}

//링크 새 웹뷰에
export function onLink(string?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToWebView',
        targetFuncParams: { url: string },
      })
    )
  }
}

//프로필 편집
export function goProfile(userId?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: `aboutfishing://aboutfishing.com/?page=editMyProfile&ownerUserId=${userId}`,
        },
      })
    )
  }
}

//유저 데이터 가져오기
export function getUserProfile(): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'getUserData',
      })
    )
  }
}

//클로즈함수 테스트해야됨
export function onClose(): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'onClose',
      })
    )
  }
}

//함수 실행
export function goFunc(payInfo?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'returnMyPay',
        targetFuncParams: { payInfo: JSON.stringify(payInfo) },
      })
    )
  }
}

//스택날리기
export function goBack(): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'goBack',
      })
    )
  }
}

// 토스트 팝업 출력
export function getToast(val?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'getToast',
        targetFuncParams: val,
      })
    )
  }
}

//리뷰 더보기 눌렀을때
export function goReivewPlus(): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'moveToLink',
        targetFuncParams: {
          url: 'aboutfishing://aboutfishing.com/?page=community&type=review',
        },
      })
    )
  }
}

//회원가입 했을때
export function registerComplete(mobile?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'shop_join_done',
          eventType: {
            os: mobile,
          },
        },
      })
    )
  }
}
//장바구니 버튼 눌러 장바구니 페이지로 이동
export function goCart(mobile?: any, productId?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'cart',
          eventType: {
            os: mobile,
            productId: productId,
          },
        },
      })
    )
  }
}
//장바구니에서 주문하기 버튼으로 주문서 페이지 이동
export function goOrder(mobile?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'purchase_step_1',
          eventType: {
            os: mobile,
          },
        },
      })
    )
  }
}

//결제 완료 시점
export function completePurchase(mobile?: any, total?: any, orderId?: any, member?: any, purchase_type?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'purchase_done',
          eventType: {
            os: mobile,
            af_revenue: total,
            af_currency: 'KRW',
            af_order_id: orderId,
            membership_type: member,
            purchase_done_type: purchase_type,
          },
        },
      })
    )
  }
}

//장바구니 삭제
export function deleteCartApp(mobile?: any, productId?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'delete_cart_item',
          eventType: {
            os: mobile,
            product_id: productId,
          },
        },
      })
    )
  }
}

//앱스플라이어 이벤트
export function postEvent(mobile?: any, price?: any, items?: any, member?: any, purchaseType?: any): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        targetFunc: 'setAppsflyerEvent',
        targetFuncParams: {
          eventName: 'purchase',
          eventType: {
            os: mobile,
            value: price,
            currency: 'KRW',
            items: items,
            membership_type: member,
            purchase_done_type: purchaseType,
          },
          // af_revenue: price,
          // currency: 'KRW',
          // af_order_id: product,
        },
      })
    )
  }
}

// 여기까지 함수 공통화 작업

export const RNPostMessage: (targetFuncName?: AFWebLinkType, params?: any) => void = (
  targetFuncName?: any,
  params?: any
): void => {
  // 리액트 네이티브로 postMessage 전송
  if (!window.ReactNativeWebView) return
  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      targetFunc: `${targetFuncName}`,
      targetFuncParams: params,
    })
  )
}

export const sendSetAppsflyerEvent: ({ eventName, eventType }: { eventName?: any; eventType?: any }) => void = ({
  eventName,
  eventType,
}: {
  eventName?: any
  eventType?: any
}): void => {
  RNPostMessage(
    AFWebLinkType.setAppsflyerEvent,
    JSON.stringify({
      eventName,
      eventType,
    })
  )
}

export const sendSetGTMAppsflyerEventEcommerce: ({
  eventName,
  eventType,
}: {
  eventName?: any
  eventType?: any
}) => void = ({ eventName, eventType }: { eventName?: any; eventType?: any }): void => {
  RNPostMessage(
    AFWebLinkType.setAppsflyerEvent,
    JSON.stringify({
      eventName,
      eventType: { ecommerce: eventType },
    })
  )
}
export const sendSetGTMAppsflyerEventEventInfo: ({
  eventName,
  eventType,
}: {
  eventName?: any
  eventType?: any
}) => void = ({ eventName, eventType }: { eventName?: any; eventType?: any }): void => {
  RNPostMessage(
    AFWebLinkType.setAppsflyerEvent,
    JSON.stringify({
      eventName,
      eventType: { event_info: eventType },
    })
  )
}

/*
interface AppsflyerEventType {
  af_order_id?: number
  af_price?: number
  
  // 쇼핑 관련 이벤트 타입 - 현재는 사용X. 추후 수정 예정
  type?: string
  section_type?: string
  section_position?: number
  item?: string
  
  // 페이지뷰 이벤트 타입
  name?: string
  class?: string
}
 */

// interface SendSetAppsflyerEvent {
//   eventName: string
//   eventType: AppsflyerEventType | object
// }

export function handlePostMessage({ actionType, params }: { actionType: string; params?: any }): void {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    let targetFunc: string = ''
    let targetFuncParams: any = {}

    switch (actionType) {
      // 링크 이동
      case 'moveToLink':
        targetFunc = 'moveToLink'
        targetFuncParams = { url: params?.url }
        break

      case 'moveToLinkDetail':
        targetFunc = 'moveToLink'
        targetFuncParams = { url: `aboutfishing://aboutfishing.com/?page=shop-main&url=${params?.url}` }
        break

      case 'moveToLinkNaver':
        targetFunc = 'moveToLink'
        targetFuncParams = { url: `aboutfishing://aboutfishing.com/?page=webview&url=${params?.url}` }
        break

      case 'moveToLinkWebviewNaver':
        targetFunc = 'moveToWebView'
        targetFuncParams = { url: `aboutfishing://aboutfishing.com/?page=webview&url=${params?.url}` }
        break

      // 주소 공유
      case 'shareUrl':
        targetFunc = 'shareUrl'
        targetFuncParams = { url: params?.url }
        break

      case 'onShopShare':
        targetFunc = 'onShopShare'
        targetFuncParams = {
          title: params?.title,
          mainImage: params?.mainImage,
          url: params?.url,
        }
        break

      case 'onSignInInducement':
        targetFunc = 'onSignInInducement'
        break

      // 링크 새 웹뷰에
      case 'onLink':
        targetFunc = 'moveToWebView'
        targetFuncParams = { url: params?.url }
        break

      // 프로필 편집
      case 'goProfile':
        targetFunc = 'moveToLink'
        targetFuncParams = { url: `aboutfishing://aboutfishing.com/?page=editMyProfile&ownerUserId=${params?.userId}` }
        break

      // 유저 데이터 조회
      case 'getUserProfile':
        targetFunc = 'getUserData'
        break

      case 'onClose':
        targetFunc = 'onClose'
        break

      // // 앱 함수 실행
      // case 'goFunc':
      //   targetFunc = 'returnMyPay';
      //   targetFuncParams = { payInfo: JSON.stringify(params?.url) };
      //   break;

      // 스택 날리기
      case 'goBack':
        targetFunc = 'goBack'
        break

      // 토스트 팝업 출력
      case 'getToast':
        targetFunc = 'getToast'
        targetFuncParams = params.val
        break

      // 리뷰 더보기
      case 'goReviewPlus':
        targetFunc = 'moveToLink'
        targetFuncParams = { url: 'aboutfishing://aboutfishing.com/?page=community&type=review' }
        break

      // 회원가입 완료
      case 'registerComplete':
        targetFunc = 'setAppsflyerEvent'
        targetFuncParams = {
          eventName: 'shop_join_done',
          eventType: { os: params?.mobile },
        }
        break

      // 장바구니 버튼 눌러 장바구니 페이지로 이동
      case 'goCart':
        targetFunc = 'setAppsflyerEvent'
        targetFuncParams = { eventName: 'cart', eventType: { os: params.mobile, productId: params.productId } }
        break

      // 장바구니에서 주문하기 버튼으로 주문서 페이지 이동
      case 'goOrder':
        targetFunc = 'setAppsflyerEvent'
        targetFuncParams = { eventName: 'purchase_step_1', eventType: { os: params.mobile } }
        break

      // 결제 완료
      case 'completePurchase':
        targetFunc = 'setAppsflyerEvent'
        targetFuncParams = {
          eventName: 'purchase_done',
          eventType: {
            os: params.mobile,
            af_revenue: params.total,
            af_currency: 'KRW',
            af_order_id: params.orderId,
            membership_type: params.member,
            purchase_done_type: params.purchase_type,
          },
        }
        break

      // 장바구니 삭제
      case 'deleteCartApp':
        targetFunc = 'setAppsflyerEvent'
        targetFuncParams = {
          eventName: 'delete_cart_item',
          eventType: {
            os: params.mobile,
            product_id: params.productId,
          },
        }
        break

      // 앱스플라이어 이벤트
      case 'postEvent':
        targetFunc = 'setAppsflyerEvent'
        targetFuncParams = {
          eventName: 'purchase',
          eventType: {
            os: params.mobile,
            value: params.price,
            currency: 'KRW',
            items: params.items,
            membership_type: params.member,
            purchase_done_type: params.purchaseType,
          },
        }
        break

      default:
        console.warn('Unknown action type')
        return
    }

    // 메시지 보내기 (targetFuncParams가 없는 경우 제외)
    const message = {
      targetFunc,
      ...(Object.keys(targetFuncParams).length > 0 && { targetFuncParams }),
    }

    // 최종 보내기
    window.ReactNativeWebView.postMessage(JSON.stringify(message))
  }
}
// handlePostMessage({actionType: 'moveToLink', params: {url: 'aboutfishing://aboutfishing.com/?page=setting'}});
